export enum PaymentMethodEnum {
  CREDIT_CARD = '0',
  BANK_TRANSFER = '1',
}
